import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card operations" }
const _hoisted_2 = { class: "card-header pb-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "grid mt-2" }
const _hoisted_5 = { class: "col-7 pb-0" }
const _hoisted_6 = { class: "col-4 pb-0" }
const _hoisted_7 = { class: "grid align-items-center" }
const _hoisted_8 = { class: "col-7 pb-0" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "col-4 pb-0" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "col-1 pb-0 text-center" }
const _hoisted_13 = { class: "flex gap-2 mt-3" }
const _hoisted_14 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldBidCPM = _resolveComponent("FieldBidCPM")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_PrimeVueDialog = _resolveComponent("PrimeVueDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    (_ctx.customBids.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.entryTitle), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.perThousand ? 'CPM' : _ctx.priceTitle), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customBids, (customBid, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "insights mt-2 mb-0 px-2 py-2",
              key: `${index}-${_ctx.renderKey}`
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "key", { customBid: customBid })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _renderSlot(_ctx.$slots, "bid", { customBid: customBid }, () => [
                      (_ctx.perThousand)
                        ? (_openBlock(), _createBlock(_component_FieldBidCPM, {
                            key: 0,
                            class: "mb-0",
                            modelValue: customBid.bid,
                            "onUpdate:modelValue": ($event: any) => ((customBid.bid) = $event),
                            modelModifiers: { number: true },
                            min: _ctx.min,
                            label: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "min"]))
                        : (_openBlock(), _createBlock(_component_FieldBidCPC, {
                            key: 1,
                            class: "mb-0",
                            modelValue: customBid.bid,
                            "onUpdate:modelValue": ($event: any) => ((customBid.bid) = $event),
                            modelModifiers: { number: true },
                            min: _ctx.min,
                            label: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "min"]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createVNode(_component_IconPark, {
                    class: "cursor-pointer text-pink-600",
                    type: "delete",
                    theme: "outline",
                    size: "16",
                    onClick: ($event: any) => (_ctx.deleteCustomBid(index))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('delete'),
                      void 0,
                      { right: true }
                    ]
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_PrimeVueButton, {
        class: "p-button-success p-button-outlined flex-1",
        icon: "pi pi-plus",
        onClick: _ctx.addCustomBid
      }, null, 8, ["onClick"]),
      (_ctx.allowBulk)
        ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
            key: 0,
            class: "p-button-success p-button-outlined flex-1",
            icon: "pi pi-list",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.bulkDialog = true))
          }, null, 512)), [
            [_directive_tooltip, _ctx.$t('add')]
          ])
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "actions", {
      customBids: _ctx.customBids,
      refresh: _ctx.refresh
    }),
    (_ctx.allowBulk)
      ? (_openBlock(), _createBlock(_component_PrimeVueDialog, {
          key: 1,
          visible: _ctx.bulkDialog,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bulkDialog) = $event)),
          header: _ctx.title,
          style: { width: '30vw' },
          breakpoints: { '960px': '75vw', '640px': '90vw' }
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_PrimeVueButton, {
              class: "p-button-outlined p-button-success w-full m-0",
              label: _ctx.$t('add'),
              icon: "pi pi-plus",
              onClick: _ctx.bulkAddCustomBids
            }, null, 8, ["label", "onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_FieldTextarea, {
                modelValue: _ctx.bulkKeysInput,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bulkKeysInput) = $event)),
                label: _ctx.entryTitle
              }, null, 8, ["modelValue", "label"]),
              (_ctx.perThousand)
                ? (_openBlock(), _createBlock(_component_FieldBidCPM, {
                    key: 0,
                    modelValue: _ctx.bulkBid,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bulkBid) = $event)),
                    modelModifiers: { number: true },
                    min: _ctx.min,
                    label: "CPM"
                  }, null, 8, ["modelValue", "min"]))
                : (_openBlock(), _createBlock(_component_FieldBidCPC, {
                    key: 1,
                    modelValue: _ctx.bulkBid,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bulkBid) = $event)),
                    modelModifiers: { number: true },
                    min: _ctx.min,
                    label: _ctx.priceTitle
                  }, null, 8, ["modelValue", "min", "label"]))
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]))
      : _createCommentVNode("", true)
  ]))
}